<div class="eiq-checkbox-card" [class.checked]="checked">
  <mat-checkbox [color]="color" [checked]="checked" (change)="change.emit($event)"> </mat-checkbox>

  <div class="eiq-checkbox-card__content">
    @if (image) {
      <div class="eiq-checkbox-card__content__image" [style.background-image]="'url(' + image + ')'"></div>
    }
    <div class="eiq-checkbox-card__content__text">
      <span class="eiq-checkbox-card__content__text-title">{{ title }}</span>
      @if (subtitle) {
        <span class="eiq-checkbox-card__content__text-subtitle">{{ subtitle }}</span>
      }
    </div>
  </div>
</div>
